"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ['coy', 'dark', 'funky', 'okaidia', 'solarizedlight', 'tomorrow', 'twilight', 'prism'];